import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumDetailsDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default enumDetailsDialogStyle;
